import React from 'react';
import {
  MainButton,
  StyledModal,
  StyledModalHeader,
  SubmitButton,
  ErrorMessage,
} from '../../../../../common/form/FormElements';
import Form from '../../../../../antd/form/Form/Form';
import { Form as AntdForm, Grid } from 'antd';
import FormFileUpload from '../../../../../antd/form/FormFileUpload/FormFileUpload';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ErrorMessages from './ErrorMessages';
import { required } from '../../../../../antd/form/FormValidation';

const CalendarInput = ({ toggle, onSubmit, validationErrors }) => {
  const { t } = useTranslation();

  const [form] = AntdForm.useForm();
  const screens = Grid.useBreakpoint();

  const initials = {
    file: undefined,
  };

  return (
    <>
      <StyledModal
        open
        onCancel={() => toggle()}
        footer={null}
        width={screens.md ? '50%' : '100%'}
      >
        <StyledModalHeader>{t('Import udalostí kalendára')}</StyledModalHeader>
        <Form onFinish={onSubmit} initialValues={initials} form={form}>
          {() => (
            <div style={{ padding: '10px' }}>
              <h4>{t('Formát importovaného súboru:')}</h4>
              <ul>
                <li>
                  {t('Pri ukladaní súboru v MS Excel je potrebné vybrať typ:')}{' '}
                  <strong>{t('CSV UTF-8 (oddelené čiarkami)')}</strong>
                </li>
                <li>
                  {t('Importovaný súbor nesmie mať na 1. riadku názvy stĺpcov')}
                </li>
                <li>
                  {t('Zoznam stĺpcov:')}{' '}
                  <strong>
                    {t(
                      'Od, Do, Názov (SK), Názov (EN), Bc, Ing, PhD, Podujatie, Špeciálna udalosť',
                    )}
                  </strong>
                </li>
                <li>
                  {t('Ak stĺpec nemá hodnotu, je potrebné ho nechať prázdny')}
                </li>
                <li>
                  {t(
                    'Oddeľovač stĺpcov je bodkočiarka, oddeľovač riadkov je nový riadok',
                  )}
                </li>
                <li>
                  {t('Špeciálna udalosť môže mať hodnotu')}:{' '}
                  <em>
                    {t(
                      'Začiatok letného semestra, Koniec letného semestra, Začiatok zimného semestra, Koniec zimného semestra',
                    )}
                  </em>
                </li>
              </ul>
              <p style={{ marginTop: '20px' }}>
                <h4>{t('Príklad jedného riadku v súbore:')}</h4>
                <em>
                  7.1.2013;;Začiatok skúšobného obdobia zimného
                  semestra.;;1;1;1;0
                </em>
              </p>

              <FormFileUpload
                label={t('Vybrať súbor')}
                name={'file'}
                rules={[required(t)]}
              />

              {form.getFieldValue('file') && (
                <p>
                  <ErrorMessage>
                    {t(
                      'V prípade, že sa v importovacom súbore nachádzajú chyby, udalosti nebudú uložené',
                    )}
                  </ErrorMessage>
                </p>
              )}

              <FormButtonsContainer>
                <MainButton onClick={() => toggle()}>{t('Zrušiť')}</MainButton>
                <SubmitButton submitOnClick={true} submitKey={'file'}>
                  {t('Nahrať')}
                </SubmitButton>
              </FormButtonsContainer>
            </div>
          )}
        </Form>

        <ErrorMessages errors={validationErrors} />
      </StyledModal>
    </>
  );
};

CalendarInput.propTypes = {
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
  validationErrors: PropTypes.any,
};

export default CalendarInput;
